import {useEffect, useState} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Progress, Alert, Row, Col} from 'reactstrap';
import RagnaWindow from '../ReactComponents/RagnaWindow';
import axios from 'axios';
import {usePrevious,wait} from '../../Globals';

const ProcessState = {
    INIT: 0,
    IDLE: 1,
    ONGOING: 2,
    FINISHED: 3,
    LOADING: 4,
    ERROR: -1
}

const DataMigration = props =>{
    const [errors, setErrors] = useState([]);
    const [ids, setIds] = useState({});
    const [currentState, setCurrentState] = useState(ProcessState.INIT);
    const prevState = usePrevious(currentState,[ProcessState.LOADING,ProcessState.ONGOING]);
    const [currentTable, setCurrentTable] = useState("");
    const [selectedTables, setSelectedTables] = useState(props.tables.map(t=>t.name));

    const getTotalCurrent = _ids => {
        var total = 0;
        for(const tbl of Object.keys(_ids)){
            if(!selectedTables.includes(tbl)) continue;
            total += _ids[tbl].current;
        }
        return total;
    }
    const getTotalOverall = _ids => {
        var total = 0;
        for(const tbl of Object.keys(_ids)){
            if(!selectedTables.includes(tbl)) continue;
            total += _ids[tbl].items?.length;
        }
        return total;
    }

    //initialize from props
    useEffect( _ => {
        var _ids = {};
        for(var t in props.tables){
            console.log(t)
            _ids = { 
                ..._ids,
                [t.name]:{
                    label: t.label,
                    current: 0,
                    items: [],
                    overwrite: t.overwrite ?? false,
                    skipFtp: t.skipFtp ?? false
                }
            };
        };
        //setIds(_ids);
    }, []);

    useEffect(_=>{
        if(errors.length > 0){
            setCurrentState(ProcessState.ERROR)
        }
    },[errors])

    const formStates = {
        [ProcessState.INIT]: {
            Buttons: [
                { 
                    label: "Check Count",
                    onClick: _ => {
                        setCurrentState(ProcessState.LOADING);
                        var flag = true;
                        setErrors([]);
                        var promises = [];
                        var _errors = [];
                        props.tables.forEach(tbl =>{
                            promises.push(axios.get(props.sync_url,{
                                params:{
                                    tbl: tbl.name
                                },
                                withCredentials: true
                            })
                                .then(response => {
                                    setIds(_ids=>({..._ids,[tbl.name]:{
                                        label: tbl.label,
                                        current: 0,
                                        items: response.data
                                    }}));
                                })
                                .catch(function (error) {
                                    // manipulate the error response here
                                    flag=false;
                                    _errors.push(error.message);
                                })
                            );
                        });
                        Promise.all(promises).then(_=>{
                            if(flag){
                                setCurrentState(ProcessState.IDLE);
                            }else{
                                setErrors(_errors);
                            }
                        })
                    }
                }
            ],
            Form: <>Press check count to get started</>
        },
        [ProcessState.IDLE]: {
            Buttons: [
                { 
                    label: "Start Migration",
                    onClick: async() => {
                            setCurrentState(ProcessState.ONGOING);
                            var flag = true;
                            var _errors = [];
                            var promises = [];
                            var forOfCounter = 0;
                            var curr = performance.now();
                            var tbl_filtered = props.tables.filter(t=>selectedTables.includes(t.name));

                            for(const tbl of tbl_filtered){
                            //((tbl, ii, tbl_arr) =>{
                                setCurrentTable(tbl.name);
                                var _items = ids[tbl.name].items;

                                for(var i=0;i<_items.length;i++){
                                    var id = _items[i];
                                    var formData = new FormData();
                                    formData.append("tbl",tbl.name);
                                    formData.append("id", id);
                                    if(tbl.overwrite) formData.append("overwrite", true);
                                    promises.push(await axios.post(props.sync_url, formData, {
                                        withCredentials: true
                                        })
                                    .then(response => {
                                        setIds(_ids => (
                                            {
                                                ..._ids,[tbl.name]:{..._ids[tbl.name], current: _ids[tbl.name].current+1}
                                            }
                                        ));
                                    })
                                    .catch(function (error) {
                                        // manipulate the error response here
                                        flag=false;
                                        _errors.push(`[${tbl.label}] -> ${error.message}`);
                                    }).then(await wait(100)))
                                }


                                
                                //await here
                                await Promise.allSettled(promises);

                                //if last call
                                if (forOfCounter === tbl_filtered.length - 1){
                                    console.log(`migration took ${(performance.now() - curr)/60000} minutes`)
                                    if(flag){
                                        setTimeout(() => {
                                            setCurrentState(ProcessState.FINISHED);
                                        }, 1000);
                                    }else{
                                        setErrors(_errors);
                                    }
                                }
                                forOfCounter++;
                            }
                    }
                }
            ],
            Form: <>
                {
                    Object.keys(ids).map((tbl,i)=>{
                        return <div key={i}>
                            <label>
                                <input type="checkbox" onChange={_=>setSelectedTables(t=>t.includes(tbl)?t.filter(tt=>tt!=tbl):[...t,tbl])} checked={selectedTables.includes(tbl)} /> {ids[tbl].label}: {ids[tbl].items?.length} Items
                            </label>
                        </div>
                    })
                }
            </>
        },
        [ProcessState.ONGOING]: {
            Form: <>Migrating.. 
                {
                    <div>
                        <Row>
                            <Col>
                        {ids[currentTable]?.label}:
                            </Col>
                            <Col style={{textAlign:"right"}}>
                                {ids[currentTable]?.current} / {ids[currentTable]?.items?.length} ({Math.round( ((ids[currentTable]?.current / ids[currentTable]?.items?.length)*100) * 100) / 100}%)
                            </Col>
                        </Row>
                        <Progress style={{height:8}} value={ids[currentTable]?.current/ids[currentTable]?.items?.length*100}>
                            
                        </Progress>
                        <Row>
                            <Col>
                                Total:
                            </Col>
                            <Col style={{textAlign:"right"}}>
                                {getTotalCurrent(ids)} / {getTotalOverall(ids)} ({Math.round((getTotalCurrent(ids)/getTotalOverall(ids)*100) * 100) / 100}%)
                            </Col>
                        </Row>
                        <Progress style={{height:8}} value={getTotalCurrent(ids)/getTotalOverall(ids)*100}>
                        </Progress>
                    </div>
                }
            </>
        },
        [ProcessState.FINISHED]: {
            Form: <>finished! show details here</>
        },
        [ProcessState.LOADING]: {
            Form: <>Loading..</>
        },
        [ProcessState.ERROR]: {
            Form: <>
                {
                    errors?.map((e,i)=>{
                        return <Alert color="danger" key={i}>
                            {e}
                        </Alert>
                    })
                }
            </>,
            Buttons: [
                {
                    onClick: _=>setCurrentState(prevState),
                    label: "Back"
                }
            ]
        }
    };

    //props.tables
    return <RagnaWindow width={props.width} title="LTS Database Migration" footer={ 
        formStates[currentState].Buttons?.map( (b,i) =>
            <button onClick={b.onClick} className='ro-button' style={{marginLeft:8}} key={i}>
                <span>{b.label}</span>
            </button>
        ) ?? null
        
    }>
        {formStates[currentState].Form}
    </RagnaWindow> 
}

export default DataMigration;